export const appUrl = {
    url: "https://apache.luxuryliving.in/api",
    key: "9d3480fc-49c4-4427-b19e-3f70d753656d",
};
